export const USER_ROLES = {
  SELF_CARE: 'self-care',
  ADVISOR: 'advisor',
  ADVISING_REPORT_PDF_GENERATOR: 'advising-report',
  NONE: '',
} as const

export type UserRole = ValueOf<typeof USER_ROLES>

export const AUTH_PRECISIONS = {
  MUST_FOLLOW_ADVICE: 'must-follow-advice',
  USER_IS_MINOR: 'user-is-minor',
} as const

export type AuthPrecision = ValueOf<typeof AUTH_PRECISIONS>

export type UserAuthDetail = {
  role: UserRole
  precisions: AuthPrecision[]
}
